import { useContext } from 'react';

import {
  HomepageTabStateContext,
  HomepageTabDispatchContext,
} from 'homepage/providers/HomepageTabProvider';

export const useHomepageTabState = () => useContext(HomepageTabStateContext);
export const useHomepageTabDispatch = () => useContext(HomepageTabDispatchContext);
